import React from 'react';
import { projectOffers } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { LatencyVignette } from './showcase/LatencyVignette';
import { CalendarVignette } from './showcase/CalendarVignette';
import { ReviveVignette } from './showcase/ReviveVignette';
import { AccountabilityDashboard } from './showcase/AccountabilityDashboard';
const visuals: React.ReactNode[] = [<LatencyVignette key="latency" data-id="element-190" data-mp="2ihgfipqjj583" />, <CalendarVignette key="calendar" data-id="element-191" data-mp="2iij8r4bc5jr6" />, <ReviveVignette key="revive" data-id="element-192" data-mp="2ijkv44xsxso7" />, <AccountabilityDashboard key="dashboard" compact data-id="element-193" data-mp="2dj6omrbumqsa" />];
export function ProjectMenu() {
  return <section id="what-i-build" aria-labelledby="what-i-build-title" className="border-b border-white/5 bg-ink-800" data-id="element-194" data-mp="2riofrdcmag4t">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-195" data-mp="2mi0d1uf10aur">
        <Reveal data-id="element-196" data-mp="6r5pz8u9pnyb">
          <h2 id="what-i-build-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-197" data-mp="6qmadys3bbng">
            What I build.
          </h2>
        </Reveal>

        <ul className="mt-10 space-y-12 sm:space-y-16" data-id="element-198" data-mp="12ry9uhhbccjt">
          {projectOffers.map((offer, index) => {
          const flipped = index % 2 === 1;
          return <li key={offer.name} data-id="element-199" data-mp="17oygati2rhbg" data-mpi={index}>
                <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-200" data-mp="1cqnugi0lgb3r">
                  <Reveal delay={0.05} className={flipped ? 'lg:order-2' : 'lg:order-1'} data-id="element-201" data-mp="f2dsg30t5ncn">
                    <div className="rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-202" data-mp="k28i638uk6w4">
                      <h3 className="font-display text-xl font-semibold tracking-tight text-white" data-id="element-203" data-mp="ozie81qqrgsx">
                        {offer.name}
                      </h3>
                      <p className="mt-2 text-sm font-semibold text-brand" data-id="element-204" data-mp="3shjt2uumlrsl">
                        {offer.price}
                      </p>
                      <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-205" data-mp="19o43rxt46cd">
                        {offer.body}
                      </p>
                    </div>
                  </Reveal>

                  <Reveal delay={0.12} className={flipped ? 'lg:order-1' : 'lg:order-2'} data-id="element-206" data-mp="3ld0pvzhzahtc">
                    {visuals[index]}
                  </Reveal>
                </div>
              </li>;
        })}
        </ul>

        <Reveal className="mt-12" data-id="element-207" data-mp="36g1gc63kgew8">
          <p className="text-sm text-white/55" data-id="element-208" data-mp="36h30d02k8bq3">
            Project work is scoped after your audit. Nothing is quoted blind.
          </p>
        </Reveal>
      </div>
    </section>;
}